export default "__VITE_ASSET__Dtw_TCbt__"